module.exports = __webpack_public_path__ + "static/media/r24.1f6cee77.png";